import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils';

import { Link } from 'react-router-dom'; 
import { FaUser } from 'react-icons/fa';



const Blog = ({ blog }) => {

  const {image, heading, content, category, admin, date} = blog; // Extracting data from blog
  const { day, shortMonth, year } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (

    <div className='blog-item'>

      <div className='image'>
        <img src={image} alt='Blog' /> {/* Blog image */}
        <Link className='blog-category' to={`/Blogs/category/${category}`}>{category}</Link> {/* Blog Category */}
      </div>

      <div className='content'>

        {/* Blog Title with dynamic navigation */}
        <Link to={{
            pathname: '/Blogs/' + heading,
          }} 
          state= {blog}
          className='main-heading'>{heading}
        </Link>

        <p>{content}</p> {/* Blog Description */}

        <div className='details'>
          <h5><div className='icon'><FaUser /></div><span>by {admin}</span></h5> {/* Blog Admin */}
          <h5><span>{day} {shortMonth}, {year}</span></h5> {/* Blog Date */}
        </div>

      </div>

    </div>
  )
}

export default Blog;